import React from "react";
import PropTypes from "prop-types";

import {
  CardBox,
  CardTitle,
  Centered,
  InformationText,
  SplitPanel
} from "../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import ClockIcon from "../../Icons/ClockIcon";
import { getMessages } from "./Waiting.helper";

const waitingCategory = "waiting_update";

export const Waiting = ({ isCurrent, description, providerName }) => {
  const t = useTranslate();
  const { title, message } = getMessages({ description, t, providerName });
  return (
    <CardBox data-category={waitingCategory}>
      <SplitPanel>
        <Centered>
          <ClockIcon />
        </Centered>
        <Centered>
          <CardTitle>{title}</CardTitle>
        </Centered>
        <InformationText>{message}</InformationText>
      </SplitPanel>
    </CardBox>
  );
};

Waiting.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  providerName: PropTypes.string.isRequired
};

export default Waiting;
